import { render } from "./AppDisclosure.vue?vue&type=template&id=fadb6dce"
import script from "./AppDisclosure.vue?vue&type=script&lang=js"
export * from "./AppDisclosure.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__